import { FiCheckCircle } from 'react-icons/fi';
import MainLayout from '../../components/Layouts/MainLayout/MainLayout';

import styles from './FormCompleted.module.css';


const FormCompleted = () => {

	return(
		<MainLayout>
			<div className='col-12 col-md-6 offset-md-3'>
				<div className={styles.Wrapper}>
					<div>
						<FiCheckCircle size={90} className='text-white mb-5' />
						<h3>Thank you for your interest</h3>
						<p>We will reach out to you with appropriate updates</p>
					</div>
				</div>
			</div>
		</MainLayout>
	)

}

export default FormCompleted;